/* =================== SERVIÇOS HOME =================== */
jQuery(document).ready(function ($) {
  $(".carrosel-servicos").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 760,
        settings: "unslick",
      },
    ],
  });
});
